<template>
  <div class="line-wrap">
    <div class="line-text" :class="{ 'no-text': !text }">{{ text }}</div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    text: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {}
  },
}
</script>
<style lang="scss">
.line-wrap {
  padding: 34px 0;
  text-align: center;
  display: flex;
  align-items: center;
  .line-text {
    white-space: nowrap;
    padding: 0 30px;
    color: #848294;
    font-size: 12px;
    &.no-text {
      padding: 0;
    }
  }
  &::before,
  &::after {
    content: '';
    width: 100%;
    height: 0;
    border-top: 1px solid #fff;
  }
}
.is-mobile {
  .line-wrap {
    padding-top: 29px;
    padding-bottom: 17px;
  }
}
</style>
